import React, { useState } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions";
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import logo from "../../assets/images/logo.svg";
import logoLight from "../../assets/images/logo-light.png";
import logoLightSvg from "../../assets/images/logo-light.svg";
import logoDark from "../../assets/images/trios-logo.jpg";
import { withTranslation } from "react-i18next";
import * as url from "../../../src/helpers/url_helper";
import { getLoggedInUser, getRefreshToken } from "../../helpers/fakebackend_helper"
import '../../assets/customstyle.css'

const Header = props => {
  const user = getLoggedInUser()
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false); // State to manage mobile menu visibility

  const onClickDrop = (from) => {
    if (from === 'Subject')
      navigate("/subjectwisemocktest");
    else if (from === 'Topic')
      navigate("/Topicwisemocktest");
    else if (from === 'Model')
      navigate("/fullLengthtest");

    setMenuOpen(false); // Close the dropdown after clicking an item
  }

  const toggleMenu = () => {
    setMenuOpen(!menuOpen); // Toggle mobile menu
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/dashboard" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="" height="37" />
                </span>
              </Link>

              <Link to="/dashboard" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="" height="19" />
                </span>
              </Link>
            </div>

          

            <Link to="/dashboard" className="nav-link dropdown-toggle arrow-none me-2" style={{ marginTop: '30px' }}>
              <i className="bx bx-home-circle me-2"></i>
              {props.t("Home")} {props.menuOpen}
            </Link>
            <Link to="/plans" className="nav-link dropdown-toggle arrow-none" style={{ marginTop: '30px' }}>
              <i className="bx bx-home-circle me-2"></i>
              {props.t("Subscription Plans")} {props.menuOpen}
            </Link>

        
          </div>

          <div className="d-flex">
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu };
};

export default

  connect(mapStatetoProps, {
    showRightSidebarAction,
    toggleLeftmenu,
  })(withTranslation()(Header));